import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { useAccordionBehavior } from '../shared';
import { AccordionContainer, AccordionPanel, AccordionHeading, AccordionControl, SpacedChevron, AccordionTabHeader, getThemeConfig, AccordionContainerTab } from '../styles';

var Accordion = function Accordion(props) {
  var _useAccordionBehavior = useAccordionBehavior(props),
      headerRefs = _useAccordionBehavior.headerRefs,
      panelRefs = _useAccordionBehavior.panelRefs,
      onHeaderClick = _useAccordionBehavior.onHeaderClick,
      onHeaderKeyDown = _useAccordionBehavior.onHeaderKeyDown,
      hideFocusOutlineStyle = _useAccordionBehavior.hideFocusOutlineStyle;

  var id = props.id,
      tabs = props.tabs,
      activeTabIndex = props.activeTabIndex,
      nested = props.nested,
      className = props.className,
      dataTest = props['data-test'],
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      theme = props.theme;
  var componentTheme = useComponentTheme({
    name: 'Accordion',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(AccordionContainer, {
    id: id,
    className: className,
    "data-test": dataTest ? dataTest : undefined,
    hideFocusOutlineStyle: hideFocusOutlineStyle,
    nested: nested
  }, tabs.map(function (tab, tabIndex) {
    var isActive = tabIndex === activeTabIndex;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: tabIndex
    }, /*#__PURE__*/React.createElement(AccordionContainerTab, {
      size: size
    }, /*#__PURE__*/React.createElement(AccordionHeading, {
      size: size,
      customTheme: componentTheme
    }, /*#__PURE__*/React.createElement(AccordionControl, {
      id: "".concat(id, "-button-").concat(tabIndex),
      "data-test": "".concat(dataTest ? dataTest : id, "-button-").concat(tabIndex),
      "aria-controls": "".concat(id, "-panel-").concat(tabIndex),
      "aria-expanded": isActive ? 'true' : 'false',
      onClick: function onClick(e) {
        return onHeaderClick(e, tabIndex);
      },
      onKeyDown: function onKeyDown(e) {
        return onHeaderKeyDown(e, tabIndex);
      },
      ref: headerRefs.current[tabIndex],
      isActive: isActive,
      nested: nested,
      size: size,
      customTheme: componentTheme
    }, /*#__PURE__*/React.createElement(AccordionTabHeader, {
      customTheme: componentTheme,
      size: size,
      nested: nested
    }, tab.header), /*#__PURE__*/React.createElement(SpacedChevron, {
      color: componentTheme.chevronIconColor,
      role: "presentation",
      pointing: isActive ? 'up' : 'down',
      size: nested ? 'xsmall' : size === 'xl' ? 'medium' : 'small',
      $customTheme: componentTheme
    }))), /*#__PURE__*/React.createElement(AccordionPanel, {
      id: "".concat(id, "-panel-").concat(tabIndex),
      "data-test": "".concat(dataTest ? dataTest : id, "-panel-").concat(tabIndex),
      "aria-labelledby": "".concat(id, "-button-").concat(tabIndex),
      isActive: isActive,
      nested: nested,
      ref: panelRefs.current[tabIndex],
      role: "region",
      tabIndex: -1,
      size: size,
      customTheme: componentTheme
    }, tab.panel)));
  }));
};

Accordion.displayName = 'Accordion';
export default Accordion;